export default __webpack_public_path__ + "static/desktop-modal-30f7c0786c5077a9b655e70495f83193.png";